import { Component } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  data: any = [{
    "parentName": "faq1",
    "isActive": false,
    "childProperties":
      [
        { "propertyName": "faq_para1" },
      ]
  },
  {
    "parentName": "faq2",
    "isActive": false,
    "childProperties":
    [
      { "propertyName": "faq_para2" },
    ]
  },
  {
    "parentName": "faq3",
    "isActive": false,
    "childProperties":
    [
      { "propertyName": "faq_para3" },
    ]
  },
  {
    "parentName": "faq4",
    "isActive": false,
    "childProperties":
    [
      { "propertyName": "faq_para4" },
    ]
  },
  {
    "parentName": "faq5",
    "isActive": false,
    "childProperties":
    [
      { "propertyName": "faq_para5" },
    ]
  },

  // {
  //   "parentName": "faq6",
  //   "isActive": false,
  //   "childProperties":
  //   [
  //     { "propertyName": "faq_para6" },
  //   ]
  // },
  // {
  //   "parentName": "faq7",
  //   "isActive": false,
  //   "childProperties":
  //   [
  //     { "propertyName": "faq_para7" },
  //   ]
  // },
];

toggleAccordian(event:any, index:any) {
  const element = event.target;
  element.classList.toggle("active");
  // if (this.data[index].isActive) {
  //   this.data[index].isActive = false;
  // } else {
  //   this.data[index].isActive = true;
  // }
  const panel = element.nextElementSibling;
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = panel.scrollHeight + "px";
  }
}
}
